"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global jRespond*/
/*global TYPO3*/
(function () {
    'use strict';
    // Create global objects
    window.gs1 = window.gs1 || {};
    TYPO3.lang = TYPO3.lang || {};
    TYPO3.settings = TYPO3.settings || {};
    var exports = {
        initializeErrorMessageHandling: function () {
            $('.certificate-order-form').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $($anchor.attr('href'));
                var targetOffset = $targetElement.offset().top;
                $('html,body').animate({
                    scrollTop: targetOffset
                }, 500, function () {
                    $targetElement.trigger('focus');
                    $targetElement.trigger('select');
                });
            });
        },
        /**
         * GS1 Product Select Element Manipulation
         */
        attachProductSelectionEvents: function () {
            $('#selectedProduct_ss10').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#selectedProduct').val($(this).val());
                    $('#selectedProduct_complete').prop('checked', false);
                }
                else {
                    $('#selectedProduct').val('');
                }
            });
            $('#selectedProduct_complete').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#selectedProduct').val($(this).val());
                    $('#selectedProduct_ss10').prop('checked', false);
                }
                else {
                    $('#selectedProduct').val('');
                }
            });
        },
        /**
         * Disable the submit button in order form after submit (a.k.a. poor man's double click/double order prevention)
         */
        attachSubmitFormEvents: function () {
            $('form[name="productUpgrade"]').submit(function () {
                $(this).find('button[type=submit]').prop('disabled', true);
            });
        },
        initializeTooltips: function () {
            $('.ean-upgrade-order-form').find('.tooltip').tooltipster();
        }
    };
    exports.initializeErrorMessageHandling();
    exports.initializeTooltips();
    exports.attachProductSelectionEvents();
    exports.attachSubmitFormEvents();
})();
